import { MealTime } from "@/clients/models/MealTime";
import { MealPreferencesService } from "@/clients/services/MealPreferencesService";
import { QueryKeys } from "@/constants/query-keys";
import { useQuery } from "@tanstack/react-query";

export const useGetMealPreferenceSuggestions = (mealTime: MealTime) => {
  const { data, isLoading, error } = useQuery({
    queryKey: [QueryKeys.MEAL_PREFERENCE_SUGGESTIONS, mealTime],
    queryFn: async () => {
      const { data } =
        await MealPreferencesService.getMealPreferenceOptionsApiV1MealPreferencesMealTimeOptionsGet(
          mealTime,
        );

      return data;
    },
  });

  return {
    suggestionOptions: data,
    isLoading,
    error,
  };
};
